import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const values = [
  {
    icon: 'ri-search-2-line',
    title: 'Analyse Personnalisée',
    color: 'fuchsia',
    items: [
      'Écoute attentive de vos besoins',
      'Évaluation de votre espace ou projet',
      'Identification des priorités et contraintes',
      'Diagnostic complet et objectif',
    ],
  },
  {
    icon: 'ri-pencil-ruler-2-line',
    title: 'Plan 3D & Recommandations',
    color: 'coral',
    items: [
      'Visualisation 3D de votre espace',
      'Proposition de plans d\'aménagement',
      'Sélection de matériaux et couleurs',
      'Moodboard personnalisé',
    ],
  },
  {
    icon: 'ri-palette-line',
    title: 'Conseils Experts',
    color: 'gold',
    items: [
      'Conseils matériaux et finitions',
      'Harmonisation des couleurs',
      'Optimisation de l\'agencement',
      'Budget et fournisseurs recommandés',
    ],
  },
];

const colorMap: Record<string, { bg: string; ring: string }> = {
  fuchsia: { bg: 'bg-brand-fuchsia', ring: 'ring-brand-fuchsia/20' },
  coral:   { bg: 'bg-brand-coral',   ring: 'ring-brand-coral/20' },
  gold:    { bg: 'bg-brand-gold',    ring: 'ring-brand-gold/20' },
};

const ValueProposition = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">
              Ce que vous obtenez
            </span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">
            Un Service de Conseil Premium
          </h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base leading-relaxed">
            Même sans projet de réalisation complète, bénéficiez de l'expertise d'Ev&amp;Co Design pour orientez vos décisions avec confiance.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((val, idx) => (
            <div
              key={val.title}
              className={`bg-brand-beige rounded-2xl p-8 transition-all duration-600 hover:-translate-y-2 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150}ms`, transitionDuration: '600ms' }}
            >
              {/* Icon */}
              <div
                className={`w-16 h-16 flex items-center justify-center rounded-full mb-6 ${colorMap[val.color].bg} ring-4 ${colorMap[val.color].ring}`}
              >
                <i className={`${val.icon} text-white text-2xl`} />
              </div>

              <h3 className="font-serif text-xl font-semibold text-brand-anthracite mb-4">
                {val.title}
              </h3>
              <div className="h-px w-10 bg-brand-gold/40 mb-5" />

              <ul className="space-y-3">
                {val.items.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-brand-coral text-sm" />
                    </div>
                    <span className="text-sm text-brand-gray leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
